import React from 'react';
import { Radio } from '@mui/material';
import classes from './RadioButton.module.scss';

export default function RadioButton(props) {
  const { label, description, checked, onChange } = props;
  return (
    <div className={classes.checkBoxWrapper}>
      <Radio onClick={onChange} checked={checked} sx={{ '& .MuiSvgIcon-root': { fontSize: 15 }, padding: 0 }} />
      <div className={classes.textsWrapper}>
        <p className={classes.checkBoxLabel}>{label}</p>
        {description && <p className={classes.checkBoxDescription}>{description}</p>}
      </div>
    </div>
  );
}
